<template>
  <admin-layout :title="`Candidato(a)s da vaga de ${job.title}`" menu="Vagas">
    <div class="row mb-3">
      <div class="col-lg-12 col-xs-12 pr-2">
        <div class="block_info_white p-2">
          <div class="row">
            <div class="col-lg-6 col-xs-12 text-truncate" style="width: 100%">
              <div class="form-group color-dark-purple mb-0">
                <h4 class="label-bold">
                  CANDIDATO(A)S DA VAGA
                  <span style="color: #8f66fe">{{ job.title }}</span>
                </h4>
              </div>
            </div>
            <div class="col-lg-3 col-xs-12">
              <a
                target="_blank"
                :href="`/recruiters/jobs/${job.id}/applies/export_no_video_candidates.csv`"
              >
                <button class="btn-new-job" style="height: 38px; width: 95%">
                  DOWNLOAD CANDIDATOS INCOMPLETOS
                </button>
              </a>
            </div>
            <div class="col-lg-3 col-xs-12">
              <inertia-link
                class="color-primary"
                :href="`/recruiters/jobs/${job.id}/kanban`"
              >
                <button class="btn-new-job">VISUALIZAÇÃO KANBAN</button>
              </inertia-link>
            </div>
            <div class="col-lg-2">
              <a
                target="_blank"
                :href="'/recruiters/jobs/' + job.id + '/applies/export.csv'"
              >
                <button type="button" class="btn btn-success">
                  DOWNLOAD CSV
                </button>
              </a>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-3 col-xs-12 p-0">
              <select
                class="form-control"
                v-model="action"
                @change="changeAction"
                :disabled="!selected.length"
              >
                <option disabled value="0">AÇÕES</option>
                <option value="1">COMPARTILHAR</option>
                <option value="2">MUDAR STATUS</option>
                <option value="3">REMOVER CANDIDATO</option>
                <option value="4">DOWNLOAD DOS PERFIS</option>
              </select>
              <label class="pt-2 position-absolut-top">
                <input type="checkbox" v-model="visibility" />
                <b>Mostar movidos</b>
              </label>
            </div>
            <div class="col-lg-3 d-flex">
              <div
                style="
                  width: 95px;
                  height: 38px;
                  margin-right: 10px !important;
                  border: 1px solid rgb(177, 176, 176);
                "
                class="nav filter-box-applie"
              >
                <li class="pointer nav-item dropdown">
                  <div
                    class="nav-link"
                    style="width: 110px; height: 38px"
                    data-toggle="dropdown"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span class="left">
                      <font-awesome-icon icon="ellipsis-v" class="mr-2" />
                    </span>
                    <span class="left">FILTRO</span>
                  </div>
                  <div class="dropdown-menu">
                    <div class="dropdown-item pointer">
                      <label class="pt-2">
                        <input type="checkbox" v-model="visibility" />
                        <b>CANDIDATO(A)S REMOVIDOS</b>
                      </label>
                    </div>
                    <div class="dropdown-item pointer">
                      <label class="pt-2">
                        <input type="checkbox" v-model="complete_videos" />
                        <b>CANDIDATO(A)S COM VÍDEO</b>
                      </label>
                    </div>
                    <div class="dropdown-item pointer">
                      <label class="pt-2">
                        <input type="checkbox" v-model="curriculum" />
                        <b>CANDIDATO(A)S COM CURRICULUM</b>
                      </label>
                    </div>
                    <div class="dropdown-item pointer">
                      <label class="pt-2">
                        <input type="checkbox" v-model="evaluated" />
                        <b>CANDIDATO(A)S AVALIADO(A)S</b>
                      </label>
                    </div>
                    <div class="dropdown-item pointer">
                      <label class="pt-2">
                        <input type="checkbox" v-model="incomplete" />
                        <b>CANDIDATO(A)S INCOMPLETOS INCLUSOS</b>
                      </label>
                    </div>
                  </div>
                </li>
              </div>
              <div
                style="
                  width: 95px;
                  height: 38px;
                  margin-right: 10px !important;
                  border: 1px solid rgb(177, 176, 176);
                "
                class="nav filter-box-applie"
              >
                <li class="pointer nav-item dropdown">
                  <div
                    class="nav-link"
                    style="width: 110px; height: 38px"
                    data-toggle="dropdown"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span class="left">
                      <font-awesome-icon icon="ellipsis-v" class="mr-2" />
                    </span>
                    <span class="left">AÇÕES</span>
                  </div>
                  <div class="dropdown-menu">
                    <div
                      class="dropdown-item pointer"
                      @click="showUploadDialog"
                    >
                      <label class="pt-2">
                        <b>UPLOAD CSV</b>
                      </label>
                    </div>
                    <a
                      class="dropdown-item pointer"
                      :href="`/recruiters/answers/${job.id}/export.csv?answered=true`"
                      target="_blank"
                    >
                      <label class="pt-2">
                        <b>DOWNLOAD CANDIDATOS COM RESPOSTAS</b>
                      </label>
                    </a>
                    <a
                      class="dropdown-item pointer"
                      :href="`/recruiters/answers/${job.id}/export.csv`"
                      target="_blank"
                    >
                      <label class="pt-2">
                        <b>DOWNLOAD CANDIDATOS SEM RESPOSTAS</b>
                      </label>
                    </a>
                    <div
                      class="dropdown-item pointer"
                      @click="showQuestionFilterDialog"
                    >
                      <label class="pt-2">
                        <b>FILTRAR POR QUESTÕES</b>
                      </label>
                    </div>
                    <div
                      class="dropdown-item pointer"
                      @click="showSelectiveProcessFilterDialog"
                    >
                      <label class="pt-2">
                        <b>FILTRAR POR PROCESSO</b>
                      </label>
                    </div>
                    <div class="dropdown-item pointer" @click="clearFilters">
                      <label class="pt-2">
                        <b>LIMPAR FILTROS</b>
                      </label>
                    </div>
                  </div>
                </li>
              </div>
            </div>

            <div class="col-lg-3"></div>
            <div class="col-lg-3 col-xs-12 pl-0">
              <div
                class="form-group mb-0 has-search d-flex justify-content-end"
              >
                <span
                  class="fa fa-search ml-2 mt-2 mr-3 form-control-feedback"
                  style="color: #212529"
                ></span>
                <input
                  type="text"
                  v-model="search"
                  v-on:keyup.enter="searchApplies"
                  class="form-control no_border"
                  style="padding: 0px"
                />
                <div class="total_apply color-dark-purple">
                  <span
                    ><b>{{ totalApplies }} CANDIDATO(A)S</b></span
                  >
                </div>
              </div>
            </div>
            <div
              v-if="is_admin"
              class="col-lg-2 col-xs-12"
              style="margin-top: 10px"
            ></div>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-xs-12">
        <div class="table-responsive">
          <table class="table mt-3">
            <thead class="headerTable">
              <tr>
                <td style="width: 5px"></td>
                <td style="min-width: 200px">
                  CANDIDATO(A)S
                  <OrderTable field="name" entity="applies" />
                </td>
                <td style="min-width: 200px" class="center">
                  PROCESSO
                  <OrderTable field="selective_process_id" entity="applies" />
                </td>
                <td style="min-width: 250px" class="center">
                  SALÁRIO
                  <OrderTable entity="applies" field="remuneration_i" />
                </td>
                <td class="center" style="min-width: 250px !important">
                  PERCENTUAL DE ACERTO
                  <OrderTable entity="applies" field="point" />
                </td>
                <td class="center" style="min-width: 300px !important">
                  AVALIAÇÃO POR COMPETÊNCIA
                  <OrderTable entity="applies" field="skills_score" />
                </td>
                <td class="center">
                  SCORE
                  <OrderTable entity="applies" field="rating_agg" />
                </td>
                <td class="center" style="min-width: 200px">
                  CARGO
                  <OrderTable entity="applies" field="last_role" />
                </td>

                <td class="center" style="min-width: 200px">
                  Like
                  <OrderTable entity="applies" field="like_candidate" />
                </td>

                <td class="center" style="min-width: 200px">
                  Deslike
                  <OrderTable entity="applies" field="deslike_candidate" />
                </td>

                <td class="center" style="min-width: 200px">
                  Star
                  <OrderTable entity="applies" field="star_candidate" />
                </td>
                <td class="center" style="min-width: 200px">
                  EMPRESA
                  <OrderTable entity="applies" field="last_business" />
                </td>
                <td class="center" style="min-width: 200px">
                  CIDADE NATAL
                  <OrderTable entity="applies" field="hometown" />
                </td>
                <td class="center" style="min-width: 200px">
                  ETNIA
                  <OrderTable entity="applies" field="ethnicity" />
                </td>
                <td class="center" style="min-width: 300px">
                  ORIENTAÇÃO SEXUAL
                  <OrderTable entity="applies" field="sexual_orientation" />
                </td>
                <td class="center" style="min-width: 300px">
                  PCD
                  <OrderTable entity="applies" field="pcd_description" />
                </td>
                <td class="center" style="min-width: 300px">
                  SCORE 1
                  <OrderTable entity="applies" field="score_1" />
                </td>
                <td class="center" style="min-width: 300px">
                  SCORE 2
                  <OrderTable entity="applies" field="score_2" />
                </td>
                <td class="center" style="min-width: 300px">
                  SCORE 3
                  <OrderTable entity="applies" field="score_3" />
                </td>
                <td class="center" style="min-width: 300px">
                  SCORE 4
                  <OrderTable entity="applies" field="score_4" />
                </td>
                <td class="center">
                  DATA
                  <OrderTable entity="applies" field="created_at" />
                </td>

                <td></td>
              </tr>
            </thead>
            <tbody class="position-relative">
              <tr
                v-for="(apply, index) in applies"
                :key="apply.id"
                :class="{ 'content-loading': loading }"
              >
                <td
                  class="center"
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                  style="border-left: 1px solid #fff"
                  :style="{
                    borderLeftColor:
                      apply.tag_color != null ? apply.tag_color : '#fff',
                    borderLeftWidth: '5px',
                  }"
                >
                  <CheckBox
                    :id="apply"
                    :index="index"
                    :checked="selected_ids.includes(apply.id)"
                  />
                </td>
                <td
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  <div class="d-flex flex-row">
                    <div>
                      <div
                        class="avatar_thumb pointer"
                        @click="show(apply.id, apply.candidate_id, index)"
                      >
                        <img class :src="apply.image || '/images/avatar.png'" />
                      </div>
                      <font-awesome-icon
                        v-if="apply.status >= 1"
                        icon="eye"
                        class="eye f13"
                        style="color: #666464; margin-left: 55px"
                      ></font-awesome-icon>
                      <font-awesome-icon
                        v-if="apply.status == 0"
                        icon="eye-slash"
                        class="eye f13"
                        style="color: #b7b7b7; margin-left: 55px"
                      ></font-awesome-icon>
                    </div>
                    <div class="ml-3 mt-1">
                      {{ apply.candidate_name }}<br />
                      <div class="pt-2">
                        <span
                          class="f14 color-white font-weight-bold p-2"
                          :style="`background-color: ${
                            apply.tag_color || 'null'
                          }; text-shadow: 0px 0px 3px black`"
                          v-if="apply.tag_name != null"
                        >
                          {{ apply.tag_name }}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
                <!-- <td :class="{selected: selected_ids.includes(apply.id)}" class="pt-3">
                <div :class="`status${apply.status}`">{{status[apply.status]}}</div>
              </td>-->
                <td
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                  class="pt-3 center"
                >
                  <div
                    class="block_process"
                    style="border-radius: 0px"
                    :class="`process${apply.selective_process_status}`"
                  >
                    {{ apply.selective_process_name }}
                  </div>
                  <div
                    v-for="(evaluation, index) in evaluations.filter(
                      (e) =>
                        e.selective_process_id == apply.selective_process_id
                    )"
                    :key="`evaluation_${apply.selective_process_id}_${index}`"
                    class="row"
                  >
                    <span
                      class="f14 mt-1"
                      style="text-align: center; width: 100%"
                    >
                      {{ getEvaluationName(evaluation) }}
                      <font-awesome-icon
                        class="color-primary"
                        :icon="getEvaluationStatus(evaluation, apply)"
                      />
                    </span>
                  </div>
                </td>
                <td
                  v-if="apply.remuneration != null"
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                  class="pt-3 center color-dark-purple"
                >
                  {{
                    apply.remuneration
                      | currency("R$ ", 2, {
                        decimalSeparator: ",",
                        thousandsSeparator: ".",
                      })
                  }}
                </td>
                <td
                  v-if="apply.remuneration === null"
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                  class="pt-3 center color-dark-purple"
                >
                  NÃO INFORMADO
                </td>
                <td
                  class="center"
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  <span v-html="hitsPercentage(apply)"></span>
                </td>
                <td
                  style="width: 550px !important"
                  class="center text-uppercase"
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  {{
                    apply.skills_score
                      ? apply.skills_score.toFixed(2) + "%"
                      : "Não avaliado(a)"
                  }}
                </td>
                <td
                  class="center"
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  <StarRating
                    class="center ajust_star"
                    active-color="#9472F8"
                    :read-only="true"
                    :rating="apply.rating_agg"
                    v-bind:max-rating="5"
                    v-bind:star-size="20"
                  ></StarRating>
                </td>

                <td class="pt-3 center color-dark-purple">
                  {{ apply.last_role }}
                </td>

                <td class="pt-3 center color-dark-purple">
                  {{ apply.like_candidate }}
                </td>

                <td class="pt-3 center color-dark-purple">
                  {{ apply.deslike_candidate }}
                </td>

                <td class="pt-3 center color-dark-purple">
                  {{ apply.star_candidate }}
                </td>

                <td class="pt-3 center color-dark-purple">
                  {{ apply.last_business }}
                </td>

                <td class="pt-3 center color-dark-purple">
                  {{
                    apply.hometown_attributes
                      ? `${apply.hometown_attributes.name}/${apply.hometown_state_attributes.name}`
                      : `Não definido`
                  }}
                </td>

                <td class="pt-3 center color-dark-purple">
                  {{ getEthnicity(apply.ethnicity) || "Não definido" }}
                </td>

                <td class="pt-3 center color-dark-purple">
                  {{
                    getSexualOrientation(apply.sexual_orientation) ||
                    "Não definido"
                  }}
                </td>

                <td class="pt-3 center color-dark-purple">
                  {{ apply.is_pcd ? apply.pcd_description : "Não" }}
                </td>

                <td class="pt-3 center color-dark-purple">
                  {{
                    apply.score_1
                      ? parseFloat(apply.score_1).toFixed(2)
                      : "Não definido"
                  }}
                </td>

                <td class="pt-3 center color-dark-purple">
                  {{
                    apply.score_2
                      ? parseFloat(apply.score_2).toFixed(2)
                      : "Não definido"
                  }}
                </td>

                <td class="pt-3 center color-dark-purple">
                  {{
                    apply.score_3
                      ? parseFloat(apply.score_3).toFixed(2)
                      : "Não definido"
                  }}
                </td>

                <td class="pt-3 center color-dark-purple">
                  {{
                    apply.score_4
                      ? parseFloat(apply.score_4).toFixed(2)
                      : "Não definido"
                  }}
                </td>

                <td
                  class="pt-3 center color-dark-purple"
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  {{ formattedDate(apply.created_at) }}
                </td>

                <td
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                  class="pt-3 center"
                >
                  <div
                    @click="show(apply.id, apply.candidate_id, index)"
                    class="center pointer"
                  >
                    <i class="fas f25 color-primary fa-file-alt"></i>
                  </div>
                </td>
              </tr>
              <div
                class="center position-absolute loading-gif"
                :class="{ 'd-none': !loading || firstLoad }"
              >
                <img src="/images/loading.gif" alt="loading-gif" />
              </div>
            </tbody>
          </table>
        </div>
        <v-pagination
          v-model="currentPage"
          :page-count="pageCount"
          class="justify-content-center"
          :class="firstLoad ? 'd-none' : 'd-flex'"
          :classes="bootstrapPaginationClasses"
        ></v-pagination>
      </div>
    </div>
  </admin-layout>
</template>

<script>
import moment from "moment";
import ApplyShow from "@/Recruiters/Applies/Show.vue";
import QuestionsFilter from "components/QuestionsFilter.vue";
import SelectiveProcessFilter from "components/SelectiveProcessFilter.vue";
import StarRating from "vue-star-rating";
import OrderTable from "components/OrderTable.vue";
import CheckBox from "components/CheckBox.vue";
import UploadApplyData from "./UploadApplyData.vue";
import ShareCandidate from "@/Recruiters/Applies/ShareCandidate.vue";
import ChangeSelectiveProcess from "@/Recruiters/Applies/ChangeSelectiveProcess.vue";
import vPagination from "vue-plain-pagination";
import { state } from "store/business.js";

export default {
  components: {
    ApplyShow,
    StarRating,
    OrderTable,
    CheckBox,
    vPagination,
    UploadApplyData,
    QuestionsFilter,
    SelectiveProcessFilter,
  },
  props: [
    "job",
    "selective_processes",
    "shortlist_uid",
    "info_tags",
    "recruiter_id",
    "is_admin",
    "evaluations",
  ],
  mounted() {
    this.action = 0;
    eventBus.$on("orderColumnapplies", (fields) => {
      this.field = fields.field;
      this.order = fields.order;
      this.searchApplies();
    });

    eventBus.$on("resetSelected", () => {
      this.selected = [];
      this.selected_ids = [];
      eventBus.$emit("no_check", true);
    });

    eventBus.$on("checkbox", (fields) => {
      let index_id = -1;
      for (let i in this.selected) {
        if (this.selected[i].id == fields.id.id) {
          index_id = i;
          break;
        }
      }
      if (index_id != -1) this.selected.splice(index_id, 1);

      const index_i = this.selected_ids.indexOf(fields.id.id);
      if (index_i > -1) this.selected_ids.splice(index_i, 1);

      if (fields.operator) {
        this.selected.push(fields.id);
        this.selected_ids.push(fields.id.id);
      }
    });
    eventBus.$on("closeQuestionFilterDialog", (params) => {
      this.$modal.hideAll();
      this.questions_filter = null;
      this.questions_filter = params;
      this.searchApplies();
    });
    eventBus.$on("closeSelectiveProcessFilterDialog", (params) => {
      this.$modal.hideAll();
      this.selective_process_filter = null;
      this.selective_process_filter = params;
      this.searchApplies();
    });
    eventBus.$on("closeApplyUploadDialog", () => {
      this.$modal.hideAll();
      this.$toast.success("ARQUIVO ENVIADO COM SUCESSO!");
      this.searchApplies();
    });
    this.searchApplies();
    this.setExtraOptions();
  },
  data: () => ({
    status: ["Não avaliado", "Visualizado", "Avaliado"],
    search: "",
    kanban: false,
    visibility: false,
    complete_videos: false,
    curriculum: false,
    evaluated: false,
    incomplete: false,
    applies: [],
    field: "",
    order: "",
    selected: [],
    selected_ids: [],
    firstLoad: true,
    loading: false,
    totalApplies: 0,
    currentPage: 1,
    pageCount: 1,
    state: state,
    aggs: null,
    questions_filter: null,
    selective_process_filter: null,
    bootstrapPaginationClasses: {
      ul: "pagination",
      li: "page-item",
      liActive: "active",
      liDisable: "disabled",
      button: "page-link",
    },
    ethnicities: [
      { id: null, name: "Não cadastrado" },
      { id: 0, name: "Indígena" },
      { id: 1, name: "Branco" },
      { id: 2, name: "Negro" },
      { id: 3, name: "Pardo" },
      { id: 4, name: "Oriental" },
      { id: 5, name: "Prefiro não informar" },
      { id: 6, name: "Indefinido" },
    ],
    sexual_orientations: [
      { id: null, name: "Não cadastrado" },
      { id: 0, name: "Heterossexual" },
      { id: 1, name: "Bissexual" },
      { id: 2, name: "Pansexual" },
      { id: 4, name: "Homossexual" },
      { id: 3, name: "Prefiro não informar" },
    ],
    action: "",
  }),
  watch: {
    currentPage: function () {
      this.searchApplies();
    },
    visibility: function () {
      this.searchApplies();
    },
    complete_videos: function () {
      this.searchApplies();
    },
    evaluated: function () {
      this.searchApplies();
    },
    curriculum: function () {
      this.searchApplies();
    },
    incomplete: function () {
      this.searchApplies();
    },
    "state.extra_options"() {
      this.setExtraOptions();
    },
  },
  methods: {
    haveRightAnswer(question) {
      let excluded_types = [0, 1, 4];
      if (excluded_types.includes(question.response_type)) return false;

      let choices = question.choices;
      if (choices.correctAnswer && choices.correctAnswer != "any") return true;

      if (question.response_type == 2) {
        return (
          choices.rightAnswers.length > 0 &&
          choices.rightAnswers.length != choices.options.length
        );
      }

      return false;
    },
    hitsPercentage(apply) {
      const details = apply?.correction_details;

      if (Object.keys(details).length === 0) return "NÃO POSSUI PORCENTAGEM";

      var html = "";

      Object.entries(details).forEach(([key, value]) => {
        html += `<br>${value.evaluation_name}: <b>${value.percentage.toFixed(
          2
        )} %</b>`;
      });

      return html;
    },
    changeAction() {
      if (this.action == 1) {
        this.showShareCandidate();
      }
      if (this.action == 2) {
        this.showChangeStatus();
      }
      if (this.action == 3) {
        this.showRemoveCandidate();
      }
      if (this.action == 4) {
        this.downloadCandidates();
      }
    },
    changeOrder(field, order) {
      this.field = field;
      this.order = order;
    },
    formattedDate(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    downloadCandidates() {
      this.selected.forEach((selected) => {
        this.download_file(
          `/recruiters/applies/${selected.id}/download.pdf`,
          "Curriculo"
        );
      });
    },
    download_file(fileURL, fileName) {
      if (fileURL) {
        var save = document.createElement("a");
        save.href = fileURL;
        save.target = "_blank";
        var filename = fileURL.substring(fileURL.lastIndexOf("/") + 1);
        save.download = fileName || filename;
        if (
          navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) &&
          navigator.userAgent.search("Chrome") < 0
        ) {
          document.location = save.href;
        } else {
          var evt = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: false,
          });
          if (save.href) {
            save.dispatchEvent(evt);
            (window.URL || window.webkitURL).revokeObjectURL(save.href);
          }
        }
      }
    },
    searchApplies() {
      if (this.search != "") {
        this.selected = [];
        this.selected_ids = [];
        eventBus.$emit("no_check", true);
      }
      let params = {};

      if (this.field != "") {
        params["order"] = {};
        params["order"][this.field] = this.order;
      }
      params["search"] = this.search;
      if (this.visibility) params["visibility"] = this.visibility;
      if (this.curriculum) params["curriculum"] = this.curriculum;
      if (this.evaluated) params["evaluated"] = this.evaluated;
      if (this.incomplete) params["incomplete"] = this.incomplete;
      if (this.complete_videos) params["completed"] = this.complete_videos;

      if (this.questions_filter) {
        params["answers"] = [this.questions_filter];
      }

      if (this.selective_process_filter) {
        params["selective_process_id"] = this.selective_process_filter;
      }

      this.loading = true;
      axios
        .get(
          `/recruiters/jobs/${this.job.id}/applies/search/${this.currentPage}`,
          {
            params: params,
          }
        )
        .then((response) => {
          console.log(response);
          this.applies = response.data.applies.apply_search;
          this.aggs = response.data.applies.aggs;
          this.totalApplies = response.data.applies.total_applies;
          this.pageCount = Math.ceil(this.totalApplies / 15);
          this.firstLoad = false;
          this.loading = false;
        });
    },
    showChangeStatus() {
      this.$modal.show(
        ChangeSelectiveProcess,
        {
          job_id: this.job.id,
          applies: this.applies,
          apply_ids: this.selected,
          selective_processes: this.selective_processes,
          selected: this.selected,
        },
        {
          width: "75%",
          height: "auto",
          scrollable: true,
        },
        {
          "before-close": (event) => {
            this.searchApplies();
            this.action = 0;
          },
        }
      );
    },
    showShareCandidate() {
      this.$modal.show(
        ShareCandidate,
        {
          job_id: this.job.id,
          apply_ids: this.selected_ids,
          selective_processes: this.selective_processes,
        },
        {
          width: "75%",
          height: "auto",
          scrollable: true,
        },
        {
          "before-close": (event) => {
            this.searchApplies();
            this.action = 0;
          },
        }
      );
    },
    showRemoveCandidate() {
      const confirm = window.confirm(
        "Tem certeza que deseja excluir o(s) candidato(s) desse processo seletivo?"
      );
      let promises = [];
      if (confirm) {
        this.selected_ids.forEach((id) => {
          promises.push(
            axios.put(`/recruiters/applies/${id}`, {
              applies: {
                visibility: false,
              },
            })
          );
        });
        Promise.all(promises).then(() => {
          this.$toast.success(
            "Candidato(s) removido(s) deste processo com sucesso!"
          );
          setTimeout(() => {
            this.searchApplies();
          }, 500);
        });
      }
    },
    show(apply_id, candidate_id, index) {
      this.$modal.show(
        ApplyShow,
        {
          index: index,
          applies: this.applies,
          job_id: this.job.id,
          job_name: this.job.title,
          job_url: this.job.url,
          apply_id: apply_id,
          candidate_id: candidate_id,
          user_manager: false,
          talent_bank_id: this.applies[index].talent_bank_id,
          recruiter_id: this.recruiter_id,
          hitsPercentage: this.applies[index].hitsPercentage,
        },
        {
          width: "90%",
          height: "auto",
          scrollable: true,
        },
        {
          "before-close": (event) => {
            this.searchApplies();
            this.action = 0;
          },
        }
      );
    },
    getEthnicity(ethnicity_id) {
      const ethnicity = this.ethnicities.find(
        (ethnicity) => ethnicity.id === ethnicity_id
      );
      if (ethnicity) {
        return ethnicity.name;
      }
      return "Não definido";
    },
    getSexualOrientation(sexual_orientation_id) {
      const sexual_orientation = this.sexual_orientations.find(
        (sexual_orientation) => sexual_orientation.id === sexual_orientation_id
      );
      if (sexual_orientation) {
        return sexual_orientation.name;
      }
      return "Não definido";
    },
    setExtraOptions() {
      if (this.state.extra_options) {
        this.state.extra_options?.ethnicity?.length > 0
          ? (this.ethnicities = this.state.extra_options?.ethnicity?.map(
              (ethnicity, index) => {
                return { name: ethnicity, id: index };
              }
            ))
          : this.ethnicities;

        this.state.extra_options?.sexual_orientation?.length > 0
          ? (this.sexual_orientations =
              this.state.extra_options?.sexual_orientation?.map(
                (sexual_orientation, index) => {
                  return { name: sexual_orientation, id: index };
                }
              ))
          : this.sexual_orientations;
      }
    },
    showUploadDialog(feedback, select_process_id, questions = false, bigfive) {
      this.$modal.show(
        UploadApplyData,
        {
          job: this.job,
        },
        {
          width: "55%",
          height: "auto",
          scrollable: true,
          // dynamicDefaults: {
          // }
        }
      );
    },
    getEvaluationName(evaluation) {
      if (evaluation) {
        return evaluation?.name || "Prova sem nome";
      }
      return "Não definido";
    },
    getEvaluationStatus(evaluation, apply) {
      let status = "envelope";
      if (
        apply.answers.find((answer) => answer.evaluation_id == evaluation.id)
      ) {
        status = "user-clock";
      }
      apply.evaluations_done_schema.forEach((evaluation_done) => {
        if (evaluation_done.evaluation_id == evaluation.id) {
          status = "check";
        }
      });
      return status;
    },
    showQuestionFilterDialog() {
      this.$modal.show(
        QuestionsFilter,
        {
          answers: this.aggs.answers,
          questions: this.job.questions,
        },
        {
          width: "90%",
          height: "auto",
          scrollable: true,
        },
        {
          "before-close": (event) => {
            this.searchApplies();
          },
        }
      );
    },
    showSelectiveProcessFilterDialog() {
      this.$modal.show(
        SelectiveProcessFilter,
        {
          selective_processes: this.selective_processes,
        },
        {
          width: "60%",
          height: "auto",
          scrollable: true,
        },
        {
          "before-close": (event) => {
            this.searchApplies();
          },
        }
      );
    },
    clearFilters() {
      this.search = "";
      this.visibility = false;
      this.complete_videos = false;
      this.curriculum = false;
      this.evaluated = false;
      this.questions_filter = null;
      this.selective_process_filter = null;
      this.searchApplies();
    },
  },
};
</script>

<style></style>
